// Breakpoint values.
var xs = 320;
var mobile = 480;
var tablet = 576;
var small = 769;
var medium = 992;
var large = 1200;
var xl = 1441;
var xxl = 1600;
var x3l = 1920;
var x4l = 2560;
export var Breakpoints = {
  xs: {
    min: 0,
    max: xs
  },
  mobile: {
    min: 0,
    max: mobile
  },
  mobileLarge: {
    min: mobile,
    max: tablet - 1
  },
  tablet: {
    min: tablet,
    max: small - 1
  },
  small: {
    min: small,
    max: medium - 1
  },
  medium: {
    min: medium,
    max: large - 1
  },
  large: {
    min: large,
    max: xl - 1
  },
  xl: {
    min: xl,
    max: xxl - 1
  },
  xxl: {
    min: xxl,
    max: x3l - 1
  },
  x3l: {
    min: x3l,
    max: x4l - 1
  },
  x4l: {
    min: x4l
  }
};